(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-slide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupAnnouncementSlide = (track) => {
      if (!(track instanceof HTMLElement)) return;
      const sequence = track.querySelector('.announcement-slide__sequence:not([data-marquee-clone])');
      if (!(sequence instanceof HTMLElement)) return;

      const existingClones = track.querySelectorAll('.announcement-slide__sequence[data-marquee-clone="true"]');
      existingClones.forEach((clone) => clone.remove());

      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      const originalWidth = sequence.getBoundingClientRect().width;

      if (originalWidth <= 0) return;

      const viewportWidth = track.parentElement?.clientWidth || window.innerWidth;
      const minCopies = Math.max(1, Math.ceil((viewportWidth * 2) / originalWidth));

      for (let copyIndex = 0; copyIndex < minCopies; copyIndex += 1) {
        const clone = sequence.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.setAttribute('data-marquee-clone', 'true');
        clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        track.appendChild(clone);
      }

      track.style.setProperty('--announcement-slide-loop-distance', `${originalWidth + gap}px`);
      track.dataset.marqueeReady = 'true';
    };

    const refreshAll = () => {
      document
        .querySelectorAll('.announcement-slide__track:not(.announcement-slide__track--static)')
        .forEach(setupAnnouncementSlide);
    };

    let resizeTimeout;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(refreshAll, 120);
    });

    if (document.readyState === 'complete') {
      refreshAll();
    } else {
      window.addEventListener('load', refreshAll, { once: true });
      document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
